// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * icons.css
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

.icon-avatar-wrapper {
	display: inline-flex;
	margin-right: 8px;
	justify-content: center;
	align-items: center;
	padding: 3px;
}

.icon-avatar {
	font-weight: bold;
	padding: 6px;
	height: 10px;
	width: 10px;
	font-size: 9px;
	color: var(--font-color-2);
}

.icon-avatar-wrapper img {
	width: 21px;
	height: 21px;
	position: relative;
	left: -2px;
	top: -1px;
}

.icon-avatar-wrapper.entity-with-img {
	padding-right: 0;

	/* Margin is different for images than for the badges because
	of their padding and other CSS reasons. */
	margin-right: 6px;
}

.icon-avatar {
	border-radius: 3px;
	background-color: var(--icon-avatar-default-background-color);
}

.icon-avatar[data-category="Workspace"] {
	border-radius: 3px;
	background-color: var(--icon-avatar-workspace-background-color);
}

.icon-avatar[data-category="Application"] {
	border-radius: 50%;
	background-color: var(--icon-avatar-component-background-color);
}

/* Application, Layout, and Action are io.CD types */
.icon-avatar[data-category="application"] {
	border-radius: 50%;
	background-color: var(--icon-avatar-application-background-color);
}

.icon-avatar[data-category="layout"] {
	border-radius: 50%;
	background-color: var(--icon-avatar-layout-background-color);
}

.icon-avatar[data-category="workspace"] {
	border-radius: 50%;
	background-color: var(--icon-avatar-swimlane-background-color);
}

.icon-avatar[data-category="action"] {
	border-radius: 50%;
	background-color: var(--icon-avatar-action-background-color);
}

/* Center the font-icons inside of the badge. Only on the toolbar, though. */
.finsemble-toolbar .icon-avatar i {
	position: relative;
	top: 2px;
}

.fsbl-tab-title .icon-avatar i {
	position: relative;
	top: 1px;
	left: 1px;
}

.fsbl-tab-title .icon-avatar {
	background-color: var(--icon-avatar-component-inactive-background-color);
	transition: background-color 300ms ease-in-out;
	box-sizing: unset;
}
`, "",{"version":3,"sources":["webpack://./src/ui/assets/css/core/icons.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;CACC,oBAAoB;CACpB,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,gBAAgB;;CAEhB;0CACyC;CACzC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,6DAA6D;AAC9D;;AAEA;CACC,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA,oDAAoD;AACpD;CACC,kBAAkB;CAClB,iEAAiE;AAClE;;AAEA;CACC,kBAAkB;CAClB,4DAA4D;AAC7D;;AAEA;CACC,kBAAkB;CAClB,8DAA8D;AAC/D;;AAEA;CACC,kBAAkB;CAClB,4DAA4D;AAC7D;;AAEA,4EAA4E;AAC5E;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,wEAAwE;CACxE,8CAA8C;CAC9C,iBAAiB;AAClB","sourcesContent":["/*!\n * icons.css\n * Copyright 2017 - 2020 by ChartIQ, Inc.\n * All rights reserved.\n */\n\n.icon-avatar-wrapper {\n\tdisplay: inline-flex;\n\tmargin-right: 8px;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 3px;\n}\n\n.icon-avatar {\n\tfont-weight: bold;\n\tpadding: 6px;\n\theight: 10px;\n\twidth: 10px;\n\tfont-size: 9px;\n\tcolor: var(--font-color-2);\n}\n\n.icon-avatar-wrapper img {\n\twidth: 21px;\n\theight: 21px;\n\tposition: relative;\n\tleft: -2px;\n\ttop: -1px;\n}\n\n.icon-avatar-wrapper.entity-with-img {\n\tpadding-right: 0;\n\n\t/* Margin is different for images than for the badges because\n\tof their padding and other CSS reasons. */\n\tmargin-right: 6px;\n}\n\n.icon-avatar {\n\tborder-radius: 3px;\n\tbackground-color: var(--icon-avatar-default-background-color);\n}\n\n.icon-avatar[data-category=\"Workspace\"] {\n\tborder-radius: 3px;\n\tbackground-color: var(--icon-avatar-workspace-background-color);\n}\n\n.icon-avatar[data-category=\"Application\"] {\n\tborder-radius: 50%;\n\tbackground-color: var(--icon-avatar-component-background-color);\n}\n\n/* Application, Layout, and Action are io.CD types */\n.icon-avatar[data-category=\"application\"] {\n\tborder-radius: 50%;\n\tbackground-color: var(--icon-avatar-application-background-color);\n}\n\n.icon-avatar[data-category=\"layout\"] {\n\tborder-radius: 50%;\n\tbackground-color: var(--icon-avatar-layout-background-color);\n}\n\n.icon-avatar[data-category=\"workspace\"] {\n\tborder-radius: 50%;\n\tbackground-color: var(--icon-avatar-swimlane-background-color);\n}\n\n.icon-avatar[data-category=\"action\"] {\n\tborder-radius: 50%;\n\tbackground-color: var(--icon-avatar-action-background-color);\n}\n\n/* Center the font-icons inside of the badge. Only on the toolbar, though. */\n.finsemble-toolbar .icon-avatar i {\n\tposition: relative;\n\ttop: 2px;\n}\n\n.fsbl-tab-title .icon-avatar i {\n\tposition: relative;\n\ttop: 1px;\n\tleft: 1px;\n}\n\n.fsbl-tab-title .icon-avatar {\n\tbackground-color: var(--icon-avatar-component-inactive-background-color);\n\ttransition: background-color 300ms ease-in-out;\n\tbox-sizing: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
